export const ADD_NOTIFICATION = 'notifications/ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'notifications/REMOVE_NOTIFICATION'

let id = 0

const defaultOptions = {
  color: "#6796e6"
}

const createNotification = (options) => {
  return {
    ...options,
    ...defaultOptions,
    id: id++
  }
}

export const removeNotification = (id) => {
  return dispatch => {
    dispatch({
      type: REMOVE_NOTIFICATION,
      payload: {
        id: id
      }
    })
  }
}

const dispatchNotification = (notification) => {
  return dispatch => {
    dispatch(notification)
    setTimeout(() => removeNotification(notification.payload.id), 15000)
  }
}

export const addInfoNotification = (title, message = 'Please allow a few minutes for the changes to propagate through the system.') => {
  let addNotification = {
    type: ADD_NOTIFICATION,
    payload: createNotification({
      title: title,
      text: message,
      type: 'info'
    })
  }

  return dispatchNotification(addNotification)
}

export const addWarnNotification = (title = "Pool is inactive.", message = 'By adding restaurants to the inactive pool you are taking a risk that restaurants will be in an incorrect offline/online state. Please contact the delivery partner so they can activate a pool by sending ETAs.') => {
  let addNotification = {
    type: ADD_NOTIFICATION,
    payload: createNotification({
      title: title,
      text: message,
      type: 'warn'
    })
  }

  return dispatchNotification(addNotification)
}

export const addErrorNotification = (title, message) => {
  let notification = {
    type: ADD_NOTIFICATION,
    payload: createNotification({
      title: title,
      text: message,
      type: 'error'
    })
  }

  return dispatchNotification(notification)
}



// WEBPACK FOOTER //
// ./src/actions/notifications.js